import PasswordTextfield from '../../PasswordTextField';
import type { FieldRendererProps } from '../types';

export function PasswordField({ field, isDisabled, sx, onChange }: FieldRendererProps) {
  return <PasswordTextfield field={field} isDisabled={isDisabled} sx={sx} onChange={onChange} />;
}
